import { Button, Dimmer, Form, Loader } from "semantic-ui-react";
import MessagePadrao from "../../components/MessagePadrao";
import { useEffect, useState } from "react";
import logo from "../NovoPedido/logo-pt2.png";
import BarraDeProgresso from "../NovoPedido/components/BarraDeProgresso";
import { useNavigate, useParams } from "react-router-dom";
import BotaoComTimer from "./components/BotaoComTimer";
import useConfirmaIdentidade from "../../hooks/useConfirmaIdentidade";
import InputCode from "./components/InputCode";
import MessageErrorsValidation from "../../components/MessageErrorsValidation";
import useTempStorage, {KEY_COOKIE_HASH_PEDIDO} from "../../hooks/useTempStorage";

function ConfirmarIdentidade() {
  const { codigo: codigoUrl } = useParams();
  const [codigo, setCodigo] = useState(codigoUrl);
  const [erro, setErro] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const { updateCookie: setHash } = useTempStorage(
    KEY_COOKIE_HASH_PEDIDO
  );

  const { isError, iniciar, concluir, temIdentificacao } =
    useConfirmaIdentidade();

  useEffect(() => {
    if (!temIdentificacao) {
      return navigate("/");
    }
    iniciar();
  }, [temIdentificacao, navigate, iniciar]);

  const confirmaCodigoHandle = async () => {
    if (!codigo) return setErro(true);

    setIsLoading(true);
    concluir(codigo).then((res) => {
      setIsLoading(false);
      setHash(res.data.hash)
      navigate("/registrar-atividade");
    }).catch(() => {
      setIsLoading(false);
      setErro(true)
    });
    
  };

  return (
    <div>
      <div className="formFiliacao formCentral">
        <div className="logo">
          <img src={logo} alt="logo pt" />
        </div>
        <div className="fraseGuia">
          Falta muito pouco! Já estou vendo uma esperança!
        </div>
        <BarraDeProgresso step={4} />
        <div className="formCampos">
          <Form>
            {isError && (
              <MessagePadrao content="Ocorreu um erro. Tente novamente!" />
            )}
            <Dimmer active={isLoading || isLoading} inverted>
              <Loader>Aguarde ...</Loader>
            </Dimmer>
            <p className="textoExplicativo">
              Para concluir seu pedido de filiação, você precisa digitar o
              código de confirmação que enviamos para o seu email.
            </p>
            <p className="textoExplicativo">
              <strong>Digite o código de confirmação:</strong>
            </p>
            <InputCode onChange={setCodigo} initial={codigo} error={erro} />
            {erro && (
              <MessageErrorsValidation
                errors={{ codigo: "Código inválido. Tente novamente!" }}
              />
            )}
            <BotaoComTimer onClick={iniciar} />
            <Button
              className="buttonAcao"
              onClick={confirmaCodigoHandle}
              primary
            >
              Confirmar
            </Button>
          </Form>
        </div>
      </div>
    </div>
  );
}

export default ConfirmarIdentidade;
